import React from "react"

function FormGroup({
  children,
  md,
  lg
}) {
  return (
    <div
      className={[
        'mz-form-group',
        md ? `col-md-${md}` : '',
        lg ? `col-lg-${lg}` : '',
      ].join(' ')}
    >
      {children}
    </div>
  )
}

export default FormGroup